export default __webpack_public_path__ + "static/82482-61a4ad22df691535887476339a1f8b0c.jpg";